import React, { Component, Fragment, ReactNode } from 'react';
import { connect } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll/modules';
import { bindActionCreators, Dispatch } from 'redux';

import { fetchUserSession } from '../actions';
import { DispatchWithState, StringKeyValue } from '../actions/types';
import Loader from '../components/Loader/Loader';
import { AppState } from '../reducers';
import { LoaderReducer } from '../reducers/loader';

interface Props {
    action: {
        fetchUserSession: () => DispatchWithState;
    };
    text: StringKeyValue;
    loader: LoaderReducer;
    children: ReactNode;
    secure: boolean;
    key: string;
}

class GlobalLoader extends Component<Props> {
    componentDidMount() {
        scroll.scrollToTop();
        const { secure, action } = this.props;
        if (secure) action.fetchUserSession();
    }

    render() {
        const { text, loader, key, secure, children } = this.props;
        const loaders = [
            {
                isLoading: secure && !loader.isLoggedIn,
                title: text.loadingDefault,
            },
            {
                isLoading: loader.isFetchingUserSession,
                title: text.loadingUser,
            },
            {
                isLoading: loader.isFetchingUserContext,
                title: text.loadingUser,
            },
            {
                isLoading: loader.isFetchingProducts,
                title: text.loadingProducts,
            },
        ];

        for (const i in loaders) {
            if (loaders[i].isLoading) return <Loader title={loaders[i].title} />;
        }
        return <Fragment key={key}>{children}</Fragment>;
    }
}

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    loader: state.loader,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    action: bindActionCreators(
        {
            fetchUserSession,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalLoader);
